
export default {
    name: 'InteractiveMapReport',
    props: {
        /**
        * Is mobile flag check.
         */
        isMobile: {
            type: Boolean,
            default: false,
        },
        /**
        * Currently selected report object.
         */
        report: {
            type: Object,
            required: true,
        },
    },
    computed: {
        roadName() {
            return this.report.road ? this.report.road.name : '';
        },
        cityName() {
            return this.report.city ? this.report.city.name : '';
        },
        clearStatus() {
            if (!this.report.id) {
                return '';
            }

            if (this.report.council_id && !this.report.cleared_at) {
                return this.$t('map.report_with_council');
            }

            if (this.report.cleared_at) {
                return `${this.$t('map.cleared')} - ${this.report.cleared_at}`;
            }

            return this.$t('map.pending');
        },
        reportDescription() {
            let { description } = this.report;
            const maxLength = this.isMobile ? 46 : 200;
            if (description.length > maxLength) {
                description = `${description.substr(0, maxLength)}...`;
            }
            return description;
        },
    },
    methods: {
        close() {
            /**
             * Close event.
             */
            this.$emit('close-modal');
        },
    },
};
